import Logger from './logger';
import { getWhitelist } from './whitelist';

export const COMMAND = {
    INVITE: 'invite',
    READY: 'ready',
    FINISH: 'finish',
    RESIZE: 'resize',
    SENDINVITERESULT: 'sendInviteResult',

    // ChatAPI only
    STARTCHAT: 'startChat',
    CLOSECHAT: 'closeChat',
    SENDMESSAGE: 'sendMessage',
    SENDTYPING: 'sendTyping'
};

export class IPC {
    constructor() {
        this.whitelist = getWhitelist();
        this.eventCallback = [];
        this.messageHandler = this.messageHandler.bind(this);
        window.addEventListener('message', this.messageHandler, true);
    }

    /** Register generic callback */
    onEvent(callback) {
        if (typeof callback === 'function') {
            this.eventCallback.push(callback);
        }
    }

    source() {
        return null;
    }

    target() {
        return null;
    }

    /** Fire registered command callbacks */
    fireEvent(event) {
        this.eventCallback.forEach(function(callback) {
            callback(event);
        }, this);
    }

    remoteWindow() {
        return window;
    }

    postMessage(json) {
        this.remoteWindow().postMessage(json, '*');
    }

    messageHandler(e) {
        if (
            this.whitelist.indexOf(
                e.origin.replace('http://', '').replace('https://', '')
            ) === -1
        ) {
            Logger.log('[IPC] Unknown origin: ' + e.origin);
            return;
        }

        const message = e.data;
        if (
            message.source &&
            message.source === this.target() &&
            message.command !== undefined
        ) {
            Logger.log(
                `[IPC] ${this.source()} received: ${JSON.stringify(e.data)}`
            );
            this.fireEvent(message);
            return true;
        }
    }

    sendEvent(command, data = null) {
        this.postMessage({
            source: this.source(),
            command: command,
            data: data
        });
    }
}
